import { useMuiSwitchableTheme } from '../../theme';

/**
 * The height of a `SearchPage`'s outer container, shared with its skeleton so
 * the two can't drift apart.
 *
 * It is the usable viewport less whatever else shares the column with the
 * container: its own `mt: 1` (8px) at every width, plus the page's 24px of
 * bottom padding on desktop. Tablets and phones have no bottom padding, so the
 * list runs right down to the browser's toolbar — but the 8px still has to
 * come off, or the page is 8px taller than the screen and the document scrolls
 * behind the list.
 * @returns A CSS height.
 */
export function useSearchPageHeight() {
  const { getUsableHeight, isTablet } = useMuiSwitchableTheme();
  return getUsableHeight(100, isTablet ? 8 : 32);
}
